import React from 'react';
import List from './List';

export default function Newsletter(): JSX.Element {
  return <List />;
}
